import { render, staticRenderFns } from "./UiModalOld.vue?vue&type=template&id=5eb76580&"
import script from "./UiModalOld.vue?vue&type=script&lang=js&"
export * from "./UiModalOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports